



































































































































































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import { montarPivot, montarBlocosDeGrade, BlocoGrade } from '@/shareds/dashboard/gerar-relatorio-grid'

@Component
export default class DialogoBuilderRelatorio extends Vue {
	@Prop({ type: Boolean, default: false }) value!: boolean
	@Prop({ type: Array, default: () => [] }) colunas!: any[]
	@Prop({ type: Array, default: () => [] }) linhas!: any[]
	@Prop({ type: String, default: '#60269E' }) corPrimaria!: string
	@Prop({ type: String, default: 'Relatório' }) titulo!: string
	@Prop({ type: String, default: '' }) empresa!: string
	@Prop({ type: Array, default: () => [] }) filtros!: any[]
	@Prop({ type: Array, default: () => [] }) templates!: any[]
	@Prop({ type: Boolean, default: false }) podeGlobal!: boolean
	@Prop({ type: String, default: '' }) usuarioId!: string

	campos: any[] = []
	quebras: any[] = []
	ordenarField: string | null = null
	ordenarDir = 'asc'
	orientacao = 'paisagem'
	subtotais = true
	totalGeral = true
	nomeTemplate = ''
	tornarGlobal = false
	templateSelecionado: any = null
	templateEditando: any = null
	arrastandoIdx = -1

	pivotAtivo = false
	pivotLinhas: any[] = []
	pivotColuna: string | null = null
	pivotValores: any[] = []
	formato = 'tabela'   // 'tabela' (pivot único) | 'blocos' (1 cartão por produto)

	@Watch('value')
	aoAbrir(aberto: boolean) {
		if (aberto) {
			this.campos = this.colunas.map(c => ({ ...c, incluir: true }))
			this.quebras = []
			this.ordenarField = null
			this.nomeTemplate = ''
			this.tornarGlobal = false
			this.templateSelecionado = null
			this.templateEditando = null
			this.pivotAtivo = false
			this.pivotLinhas = []
			this.pivotColuna = null
			this.pivotValores = []
			this.formato = 'tabela'
			// Ao abrir, já pré-seleciona e carrega o template padrão (estrela) do relatório.
			const padrao = this.templatePadrao
			if (padrao) {
				this.templateSelecionado = padrao
				this.carregarTemplate()
			}
		}
	}

	get camposPivotTodos(): any[] { return this.campos.filter(c => c.incluir) }
	get camposPivotValores(): any[] { return this.campos.filter(c => c.incluir && c.numerico) }
	get pivotLinhasFields(): string[] {
		const vistos = new Set<string>()
		return this.pivotLinhas.map((l: any) => l.field).filter((f: string) => f && !vistos.has(f) && vistos.add(f))
	}
	get pivotValoresFields(): string[] {
		const vistos = new Set<string>()
		return this.pivotValores.map((v: any) => v.field).filter((f: string) => f && !vistos.has(f) && vistos.add(f))
	}
	adicionarLinha() { this.pivotLinhas.push({ field: '' }) }
	removerLinha(i: number) { this.pivotLinhas.splice(i, 1) }
	adicionarValor() { this.pivotValores.push({ field: '' }) }
	removerValor(i: number) { this.pivotValores.splice(i, 1) }
	get pivotValido(): boolean { return this.pivotAtivo && this.pivotLinhasFields.length > 0 && !!this.pivotColuna && this.pivotValoresFields.length > 0 }
	get pivotConfig(): any {
		if (!this.pivotValido) return null
		return {
			colunaField: this.pivotColuna,
			linhas: this.pivotLinhasFields.map(f => ({ field: f, header: this.headerDe(f) })),
			valores: this.pivotValoresFields.map(f => {
				const c = this.campos.find(x => x.field === f)
				return { field: f, header: this.headerDe(f), moeda: !!(c && c.moeda) }
			}),
		}
	}
	get dadosPivot(): { colunas: any[]; linhas: any[] } {
		if (!this.pivotValido) return { colunas: [], linhas: [] }
		return montarPivot(this.linhas || [], this.pivotConfig)
	}
	get ehBlocos(): boolean { return this.pivotAtivo && this.formato === 'blocos' }
	get imagemField(): string | null {
		const c = this.campos.find(c => c.incluir && /(imagem|foto|img|thumb|avatar)/i.test((c.header || '') + ' ' + (c.field || '')))
		return c ? c.field : null
	}
	get blocoConfig(): any {
		if (!this.pivotValido) return null
		return {
			idFields: this.pivotLinhasFields.map(f => ({ field: f, header: this.headerDe(f) })),
			colunaField: this.pivotColuna,
			metricas: this.pivotValoresFields.map(f => {
				const c = this.campos.find(x => x.field === f)
				return { field: f, header: this.headerDe(f), moeda: !!(c && c.moeda) }
			}),
			imagemField: this.imagemField,
		}
	}
	get todosOsBlocos(): BlocoGrade[] {
		if (!this.ehBlocos || !this.blocoConfig) return []
		return montarBlocosDeGrade(this.linhasOrdenadas || [], this.blocoConfig)
	}
	get totalBlocos(): number { return this.todosOsBlocos.length }
	get blocosPreview(): BlocoGrade[] { return this.todosOsBlocos.slice(0, 6) }
	get blocosPreviewTruncado(): boolean { return this.totalBlocos > this.blocosPreview.length }
	fmtNum(v: number, moeda: boolean): string {
		if (v === null || v === undefined) return ''
		if (moeda) return 'R$ ' + this.toNum(v).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
		return this.toNum(v).toLocaleString('pt-BR')
	}
	get pivotQtdColunas(): number { return this.pivotValido ? Math.max(0, this.dadosPivot.colunas.length - 1) : 0 }
	get cabecalhoGrupos(): any[] {
		const grupos: any[] = []
		this.previewColunas.forEach((c: any) => {
			const g = c.grupo || null
			const last = grupos[grupos.length - 1]
			if (last && last.nome === g && g !== null) last.cols.push(c)
			else grupos.push({ nome: g, cols: [c] })
		})
		return grupos
	}

	get corClara(): string { return this.clarear(this.corPrimaria, 0.9) }
	clarear(hex: string, fator: number): string {
		const h = (hex || '').replace('#', '')
		if (h.length !== 6) return '#EEEDFE'
		const n = [0, 2, 4].map(i => parseInt(h.slice(i, i + 2), 16))
		const mix = (c: number) => Math.round(c + (255 - c) * fator)
		return `#${n.map(c => mix(c).toString(16).padStart(2, '0')).join('')}`
	}
	escurecer(hex: string, fator: number): string {
		const h = (hex || '').replace('#', '')
		if (h.length !== 6) return '#2a1a4a'
		const n = [0, 2, 4].map(i => parseInt(h.slice(i, i + 2), 16))
		const mix = (c: number) => Math.round(c * (1 - fator))
		return `#${n.map(c => mix(c).toString(16).padStart(2, '0')).join('')}`
	}
	get gradiente(): string { return `linear-gradient(135deg, ${this.escurecer(this.corPrimaria, 0.5)} 0%, ${this.corPrimaria} 100%)` }

	get geradoEm(): string { return new Date().toLocaleDateString('pt-BR') }
	get opcoesQuebra(): any[] { return this.campos.filter(c => c.incluir) }
	get quebraFields(): string[] { return this.pivotValido ? [] : this.quebras.map((q: any) => q.field).filter(Boolean) }
	get previewColunas(): any[] {
		if (this.pivotValido) return this.dadosPivot.colunas
		return this.campos.filter(c => c.incluir && !this.quebraFields.includes(c.field))
	}
	get temTotais(): boolean { return this.previewColunas.some(c => c.aggFunc) }
	headerDe(f: string): string { const c = this.campos.find(x => x.field === f); return c ? c.header : f }
	adicionarQuebra() { this.quebras.push({ field: '' }) }
	removerQuebra(i: number) { this.quebras.splice(i, 1) }
	get editandoProprio(): boolean { const t = this.templateEditando; return !!t && (!t.global || t.usuarioId === this.usuarioId) }
	get podeRemoverSelecionado(): boolean { const t = this.templateSelecionado; return !!t && (!t.global || t.usuarioId === this.usuarioId) }
	// Favorito é pessoal: só vale se o template é do próprio usuário e está marcado como favorito.
	get ehPadrao(): boolean { const t = this.templateSelecionado; return !!t && !!t.favorito && t.usuarioId === this.usuarioId }
	// Só é possível favoritar (estrela) um template próprio.
	get podeFavoritar(): boolean { const t = this.templateSelecionado; return !!t && t.usuarioId === this.usuarioId }
	// Template a carregar ao abrir: favorito pessoal do usuário → compartilhado (global) → primeiro.
	get templatePadrao(): any {
		const list = this.templates || []
		if (!list.length) return null
		return list.find((t: any) => t.favorito && t.usuarioId === this.usuarioId)
			|| list.find((t: any) => t.global)
			|| list[0]
	}
	alternarPadrao() {
		if (!this.templateSelecionado || !this.podeFavoritar) return
		const novo = !this.ehPadrao
		// Atualização otimista para a estrela refletir na hora (o pai persiste + recarrega).
		this.$set(this.templateSelecionado, 'favorito', novo)
		this.$emit('marcar-padrao', { presetId: this.templateSelecionado.id, favorito: novo })
	}
	alternarCompartilhar() {
		if (!this.templateSelecionado || !this.podeGlobal) return
		const t = this.templateSelecionado
		const novoGlobal = !t.global
		const config = (t.presetSalvo && (t.presetSalvo.config || t.presetSalvo)) || this.configAtual()
		this.$emit('salvar-template', { id: t.id, nome: t.nome, global: novoGlobal, config })
		this.$set(t, 'global', novoGlobal)
		this.tornarGlobal = novoGlobal
	}

	chipTexto(c: any): string { return c.moeda ? 'R$' : (c.numerico ? '#' : 'Aa') }
	chipEstilo(c: any): any {
		if (c.moeda) return { background: '#E1F5EE', color: '#0F6E56' }
		if (c.numerico) return { background: '#E6F1FB', color: '#0C447C' }
		return { background: '#EEEDFE', color: '#3C3489' }
	}

	toNum(v: any): number { const n = Number(v); return isNaN(n) ? 0 : n }
	fmtVal(v: any, col: any): string {
		if (v === null || v === undefined || v === '') return ''
		if (col.moeda) return 'R$ ' + this.toNum(v).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
		if (col.numerico) { const n = Number(v); return isNaN(n) ? String(v) : n.toLocaleString('pt-BR') }
		return String(v)
	}
	ehImagem(v: any, col: any): boolean {
		if (typeof v !== 'string') return false
		const s = v.trim()
		if (!/^https?:\/\//i.test(s) && !/^data:image\//i.test(s)) return false
		const dica = /(imagem|image|foto|img|logo|thumb|avatar)/.test(((col.header || '') + ' ' + (col.field || '')).toLowerCase())
		const ext = /\.(png|jpe?g|gif|webp|bmp|svg)(\?|#|$)/i.test(s)
		return dica || ext
	}
	celTotal(itens: any[], col: any): string {
		if (!col.aggFunc) return ''
		const nums = itens.map(i => Number(i[col.field])).filter(n => !isNaN(n))
		let r = 0
		switch (col.aggFunc) {
			case 'sum': r = nums.reduce((a, b) => a + b, 0); break
			case 'avg': r = nums.length ? nums.reduce((a, b) => a + b, 0) / nums.length : 0; break
			case 'min': r = nums.length ? Math.min(...nums) : 0; break
			case 'max': r = nums.length ? Math.max(...nums) : 0; break
			case 'count': return String(itens.length)
			default: return ''
		}
		return this.fmtVal(r, col)
	}

	get linhasOrdenadas(): any[] {
		const base = (this.linhas || []).slice()
		if (this.ordenarField) {
			const f = this.ordenarField
			base.sort((a, b) => {
				const x = a[f]; const y = b[f]
				let r: number
				if (typeof x === 'number' && typeof y === 'number') r = x - y
				else r = String(x ?? '').localeCompare(String(y ?? ''), 'pt-BR', { numeric: true })
				return this.ordenarDir === 'desc' ? -r : r
			})
		}
		return base
	}
	get linhasEfetivas(): any[] {
		return this.pivotValido ? this.dadosPivot.linhas : this.linhasOrdenadas
	}
	get linhasRender(): any[] {
		if (this.pivotValido) return this.dadosPivot.linhas.map((r: any) => ({ tipo: 'data', row: r }))
		const out: any[] = []
		const fields = this.quebraFields
		const build = (rows: any[], lvl: number) => {
			if (lvl >= fields.length) { rows.forEach(r => out.push({ tipo: 'data', row: r })); return }
			const f = fields[lvl]
			const map = new Map<string, any[]>()
			rows.forEach(r => { const k = String(r[f] ?? '—'); if (!map.has(k)) map.set(k, []); map.get(k)!.push(r) })
			map.forEach((itens, chave) => {
				out.push({ tipo: 'grupo', level: lvl, header: this.headerDe(f), chave, count: itens.length })
				build(itens, lvl + 1)
				if (this.subtotais) out.push({ tipo: 'sub', level: lvl, itens })
			})
		}
		build(this.linhasOrdenadas, 0)
		return out
	}

	onDragStart(i: number) { this.arrastandoIdx = i }
	onDrop(i: number) {
		if (this.arrastandoIdx < 0 || this.arrastandoIdx === i) return
		const arr = this.campos.slice()
		const [m] = arr.splice(this.arrastandoIdx, 1)
		arr.splice(i, 0, m)
		this.campos = arr
		this.arrastandoIdx = -1
	}

	configAtual(): any {
		return {
			tipo: 'relatorio-pdf',
			ordem: this.campos.filter(c => c.incluir).map(c => c.field),
			quebraFields: this.quebraFields,
			ordenarField: this.ordenarField,
			ordenarDir: this.ordenarDir,
			orientacao: this.orientacao,
			subtotais: this.subtotais,
			totalGeral: this.totalGeral,
			pivot: this.pivotConfig,
			formato: this.ehBlocos ? 'blocos' : 'tabela',
		}
	}
	carregarTemplate() {
		const t = this.templateSelecionado
		const cfg = t && t.presetSalvo ? (t.presetSalvo.config || t.presetSalvo) : null
		if (!cfg) { this.templateEditando = null; return }
		const ordem: string[] = cfg.ordem || []
		this.campos.forEach(c => { c.incluir = ordem.length ? ordem.includes(c.field) : true })
		if (ordem.length) {
			const incluidos = ordem.map(f => this.campos.find(c => c.field === f)).filter(Boolean) as any[]
			const resto = this.campos.filter(c => !ordem.includes(c.field))
			this.campos = [...incluidos, ...resto]
		}
		const qf: string[] = cfg.quebraFields || (cfg.quebraField ? [cfg.quebraField] : [])
		this.quebras = qf.map(field => ({ field }))
		this.ordenarField = cfg.ordenarField ?? null
		this.ordenarDir = cfg.ordenarDir ?? 'asc'
		this.orientacao = cfg.orientacao ?? 'paisagem'
		this.subtotais = cfg.subtotais ?? true
		this.totalGeral = cfg.totalGeral ?? true
		const pv = cfg.pivot
		const valoresPv = pv ? (pv.valores ? pv.valores.map((v: any) => v.field) : (pv.valorField ? [pv.valorField] : [])) : []
		const linhasPv = pv ? (pv.linhas ? pv.linhas.map((l: any) => l.field) : (pv.linhaField ? [pv.linhaField] : [])) : []
		if (pv && linhasPv.length && pv.colunaField && valoresPv.length) {
			this.pivotAtivo = true
			this.pivotLinhas = linhasPv.map((f: string) => ({ field: f }))
			this.pivotColuna = pv.colunaField
			this.pivotValores = valoresPv.map((f: string) => ({ field: f }))
			this.formato = cfg.formato === 'blocos' ? 'blocos' : 'tabela'
		} else {
			this.pivotAtivo = false
			this.pivotLinhas = []
			this.pivotColuna = null
			this.pivotValores = []
			this.formato = 'tabela'
		}
		this.templateEditando = t
		this.nomeTemplate = t.nome
		this.tornarGlobal = !!t.global
	}
	salvarTemplate(comoNovo = false) {
		const atualizando = !comoNovo && this.editandoProprio
		this.$emit('salvar-template', {
			id: atualizando ? this.templateEditando.id : null,
			nome: this.nomeTemplate.trim(),
			global: this.tornarGlobal && this.podeGlobal,
			config: this.configAtual(),
		})
		if (!atualizando) { this.nomeTemplate = ''; this.tornarGlobal = false; this.templateEditando = null }
	}
	removerTemplate() {
		if (!this.templateSelecionado || !this.podeRemoverSelecionado) return
		this.$emit('remover-template', this.templateSelecionado.id)
		this.templateSelecionado = null
	}
	gerar() {
		const colunas = this.previewColunas.map(c => ({ header: c.header, field: c.field, numerico: c.numerico, moeda: c.moeda, aggFunc: c.aggFunc }))
		this.$emit('gerar', {
			colunas, quebraFields: this.quebraFields, ordenarField: this.ordenarField, ordenarDir: this.ordenarDir,
			orientacao: this.orientacao, subtotais: this.subtotais, totalGeral: this.totalGeral,
			pivot: this.pivotConfig,
			formato: this.ehBlocos ? 'blocos' : 'tabela',
			imagemField: this.imagemField,
		})
		this.$emit('input', false)
	}
}
